import React from "react";
import {
  useRetrieveCurrentPlanzone,
  useRetrieveSecondaryCriteriaTemplate,
} from "@planzone/view-models";
import { useTranslation } from "react-i18next";
import { SelectList } from "@common/selectList";
import { ColumnIcon } from "../columnIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function Form({ project, lang, formData, edit }: Props) {
  const { t, i18n } = useTranslation();
  const { planzone } = useRetrieveCurrentPlanzone();
  const { template: planzoneTemplate } = useRetrieveSecondaryCriteriaTemplate(
    planzone.uuid,
    "projectElement",
  );
  const { template: projectTemplate } = useRetrieveSecondaryCriteriaTemplate(
    project.uuid,
    "projectElement",
  );
  const template = [
    ...planzoneTemplate.map((sc) => ({ ...sc, isLocal: false })),
    ...projectTemplate.map((sc) => ({ ...sc, isLocal: true })),
  ];
  const columns = template
    .map((criteria) => ({
      ...criteria,
      name: criteria.labels[lang as keyof typeof criteria.labels]
        ? criteria.labels[lang as keyof typeof criteria.labels]
        : criteria.name,
    }))
    .filter(({ uuid }) => !formData.columns.find(({ key }) => key === uuid));

  return (
    <SelectList listClassName={styles.listRoot}>
      {({ select }) => ({
        input: (
          <div className={styles.input}>
            <p>{t("projectElementDetailsConfiguration.addColumn")}</p>
          </div>
        ),
        list: (
          <div className={styles.list}>
            {columns.map((column) => (
              <div
                key={column.uuid}
                className={styles.item}
                onClick={() =>
                  edit({
                    ...formData,
                    columns: [...formData.columns, { key: column.uuid }],
                  })
                }
              >
                <ColumnIcon
                  project={project}
                  criteriaKey={column.uuid}
                  className={styles.icon}
                />
                <p className={styles.name}>
                  {column.name}
                  {"isLocal" in column && column.isLocal
                    ? ` (${t("projectElementDetailsConfiguration.localCriteria")})`
                    : ""}
                </p>
              </div>
            ))}
          </div>
        ),
      })}
    </SelectList>
  );
}

export { Form };
